import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cotizar',
  templateUrl: './cotizar.component.html',
  styleUrls: ['./cotizar.component.scss']
})
export class CotizarComponent implements OnInit {

  tipos = [
    {
      imagen: '',
      titulo: 'Vehículo Particular',
      url: '/cotizar/personaNatural'
    },
    {
      imagen: '',
      titulo: 'Compañía Logística',
      url: '/cotizar/empresa'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
